import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNoteText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNoteText"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V14.5H14.5V21H3ZM8 8H16V9.5H8V8ZM8 12V13.5H12V12H8Z" fill="currentColor"/><Path d="M16 21H16.3107L21 16.3107V16H16V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNoteText;
